<!-- SLIM FOOTER FOR REQUEST FLOW & SIGN IN (MATCHING HANDOFF) -->
<footer *ngIf="isSlimFooter" class="slim-footer">
    <div class="slim-footer-container">
        <span>© 2026 speKwo, LLC · <a href="tel:7046261776">704.626.1776</a> · <a href="mailto:info@spekwo.com">info@spekwo.com</a></span>
        <div class="slim-legal-links">
            <a routerLink="/terms-conditions">Terms</a>
            <a routerLink="/privacy-policy">Privacy</a>
        </div>
    </div>
</footer>

<footer *ngIf="!isSlimFooter" class="new-footer">

    <div class="footer-container">

        <div class="footer-grid">

            <!-- BRAND -->
            <div class="footer-brand">

                <a
                    routerLink="/"
                    class="footer-logo"
                >
                    spe<span>K</span>wo
                </a>

                <p>
                    Neutral, consistent repair-cost quotes on
                    home-inspection items in 24–72 hours,
                    completed in-house by full-time tradesmen.
                    Founded in Charlotte, North Carolina.
                </p>

            </div>


            <!-- CONTACT -->
            <div class="footer-column">

                <div class="footer-heading">
                    CONTACT
                </div>

                <div class="footer-links">

                    <a href="tel:7046261776">
                        704-626-1776
                    </a>

                    <a href="mailto:info@spekwo.com">
                        info@spekwo.com
                    </a>

                    <address>
                        <a
                            href="https://maps.google.com/?q=19701+Bethel+Church+Road+Suite+103-119+Cornelius+NC+28031"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            19701 Bethel Church Road<br>
                            Suite 103-119<br>
                            Cornelius, NC 28031
                        </a>
                    </address>

                </div>

            </div>


            <!-- SERVICE AREA -->
            <div class="footer-column">

                <div class="footer-heading">
                    SERVICE AREA
                </div>

                <div class="footer-links">

                    <a routerLink="/service-area-asheville">
                        Asheville
                    </a>

                    <a routerLink="/service-area-charlotte">
                        Greater Charlotte
                    </a>

                    <a routerLink="/service-area-upstate-sc">
                        Upstate SC
                    </a>

                    <a routerLink="/service-area-raleigh">
                        Raleigh
                    </a>

                    <a routerLink="/service-area-triad">
                        The Triad
                    </a>

                </div>

            </div>


            <!-- EXPLORE -->
            <div class="footer-column">

                <div class="footer-heading">
                    EXPLORE
                </div>

                <div class="footer-links">

                    <a routerLink="/about">
                        About
                    </a>

                    <a routerLink="/faq">
                        FAQ
                    </a>

                    <a routerLink="/testimonials">
                        Testimonials
                    </a>

                    <a routerLink="/contact">
                        Contact
                    </a>

                    <a
                        href="https://www.facebook.com/SpeKwo-344051736111918/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Facebook
                    </a>

                    <a
                        href="https://instagram.com/spekwo.us"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Instagram
                    </a>

                </div>

            </div>

        </div>


        <!-- BOTTOM -->
        <div class="footer-bottom">

            <span>
                © 2026 speKwo · Home inspection repair quotes &
                repairs · Serving Charlotte, Raleigh, Asheville,
                the Triad & Upstate SC
            </span>

            <div class="footer-legal">

                <a routerLink="/terms-conditions">
                    Terms
                </a>

                <a routerLink="/privacy-policy">
                    Privacy
                </a>

            </div>

        </div>

    </div>

</footer>